import { ChangeDetectorRef, Component, DestroyRef, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { DialogComponent } from '../../shared/components/dialog/dialog.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { PrivacyService } from '../../services/privacy/privacy.service';
import { PrivacydialogComponent } from '../../shared/components/privacydialog/privacydialog.component';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { startWith } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
  standalone: false
})
export class LandingComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  private readonly privacyNoticeHeaderState = signal('Privacy Notice');
  get privacyNoticeHeader() { return this.privacyNoticeHeaderState(); }
  set privacyNoticeHeader(value: string) { this.privacyNoticeHeaderState.set(value); }
  constructor(
    private dialogService: DialogService,
    private privacyService: PrivacyService,
    private router: Router, private translateService: TranslateService,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  private privacyDialogRef: DynamicDialogRef | null = null;
  ngOnInit() {
    this.privacyService.resetPrivacyAcceptance();
    this.translateService.onLangChange
      .pipe(
        startWith({ lang: this.translateService.getCurrentLang() ?? this.translateService.getFallbackLang() } as LangChangeEvent),
        takeUntilDestroyed(this.destroyRef))
      .subscribe((event: LangChangeEvent) => {
        this.updatePageData();
      });
  }

  updatePageData() {
    const translationKeys = ['privacyNotice'];
    this.translateService.get(translationKeys).subscribe(res => {
      this.privacyNoticeHeader = res?.privacyNotice;
      this.changeDetectorRef.detectChanges();
    });
  }

  proceed() {
    if (!this.privacyService.isPrivacyAccepted()) {
      this.openPrivacyDialog();
    } else {
      console.log('privacy accepted in storage');
    }
  }

  openPrivacyDialog() {
    const lang = this.translateService.getCurrentLang() ?? this.translateService.getFallbackLang() ?? 'EN';
    this.privacyService.loadPrivacyNoticeDialogContent(lang).subscribe((content) => {
      this.privacyDialogRef = this.dialogService.open(PrivacydialogComponent, {
        header: this.privacyNoticeHeader,
        width: '80%',
        contentStyle: { 'max-height': '90vh', overflow: 'auto' },
        baseZIndex: 10000,
        modal: true,
        closable: true,
        data: {  selectedLanguage: lang, privacyNoticeContent: content
         }
      });

      this.privacyDialogRef?.onClose.subscribe((result: any) => {
        if (result) {
          this.privacyService.setPrivacyAccepted(true);
          console.log('acknowledged');
          // emit to navbar to hide the language sign
          this.privacyService.setHideSignLang(true);
          this.router.navigate(['/generate-invoice']);
        }
      });
    });

  }
}
